import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=9f9c3020"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=9f9c3020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports